// src/services/FinancialService.js
import { HTTP } from "@/utils/http-common"

export default {
  getFinancialReport($, eventId = null, params = {}) {
    return new Promise((resolve, reject) => {
      const endpoint = eventId ? `/event/${eventId}/financial-report` : `/event/financial-report`

      HTTP.get(endpoint, { params })
        .then(response => resolve(response.data))
        .catch(error => {
          const msg = error?.response?.data?.error || "Erreur lors du chargement du rapport"
          $.$store.commit("app/message", {
            msg: msg,
            color: "error"
          })
          reject(error)
        })
    })
  }
}
